import { ValueSource, ConditionComparison } from '../Condition';
import { ValidationError } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/ValidatorError';
export class ConditionValidator {
    validate(model) {
        // Workaround for old Desk Template that has comparison as 'Equals'
        // TODO: Remove after 12/08/2019
        if (model.comparison.toString() === 'Equals') {
            model.comparison = ConditionComparison.Equals;
        }
        switch (model.comparison) {
            case ConditionComparison.Exists:
            case ConditionComparison.NotExists:
                if (model.values !== undefined && model.values.length > 0) {
                    throw new ValidationError('The condition values should not be provided if comparison is Exists or NotExists');
                }
                break;
            case ConditionComparison.Equals:
            case ConditionComparison.NotEquals:
            case ConditionComparison.Contains:
            case ConditionComparison.StartsWith:
            case ConditionComparison.EndsWith:
            case ConditionComparison.GreaterThan:
            case ConditionComparison.LessThan:
            case ConditionComparison.GreaterThanOrEquals:
            case ConditionComparison.LessThanOrEquals:
            case ConditionComparison.ApproximateTo:
            case ConditionComparison.Matches:
                if (model.values === undefined || model.values.length == 0) {
                    throw new ValidationError('The condition values must be provided');
                }
                break;
            default:
                throw new ValidationError('Unknown condition comparison');
        }
        if (model.source === undefined || model.comparison === undefined) {
            throw new ValidationError('Invalid output condition (i.e., source or comparison missing)');
        }
        if (model.source == ValueSource.Context && !model.variable) {
            throw new ValidationError('The variable name should be provided if the comparsion source is context');
        }
        if (model.source == ValueSource.Entity && !model.entity) {
            throw new ValidationError('The entity name should be provided if the comparsion source is entity');
        }
    }
}
